import { render } from "./baseinput.vue?vue&type=template&id=2f2284e2&scoped=true"
import script from "./baseinput.vue?vue&type=script&lang=js"
export * from "./baseinput.vue?vue&type=script&lang=js"

import "./baseinput.vue?vue&type=style&index=0&id=2f2284e2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2284e2"]])

export default __exports__